<template>
	<v-row>
		<v-col>
			<v-responsive
					:aspect-ratio="1/2"
					class="grey lighten-4 mx-auto rounded-xl"
					min-width="calc(min(calc(100vw), calc(512px)) - 2rem)"
					max-width="512px"
			>
				<mobile-pass-preview :preview-url="extraData.previewUrl"></mobile-pass-preview>
			</v-responsive>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'PreviewPass',
	props: {
		extraData: {
			type: Object,
			default: () => ({})
		}
	},
}
</script>

<style scoped lang="scss">
</style>
